import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { ArrowDown, Cross, Filter, RefreshArrow, Search } from "../../assets";
import { debounce } from "../../utils/helpers";

export default function RecipeSearchBar({
	setSearchTerm,
	seasonTags,
	setSeasonFilter,
	totalFilter,
	dietTags,
	setDietFilter,
	showFilters,
	setShowFilters,
	dietFilter,
}) {
	const setInput = debounce((value) => {
		setSearchTerm(value);
	}, 800);
	const debouceRequest = useCallback((value) => setInput(value), [setInput]);
	const [seasonChecked, setSeasonChecked] = useState("");
	const [dietChecked, setDietChecked] = useState("");
	const { t } = useTranslation();

	const onChangeSeason = (value) => {
		setSeasonChecked(value);
	};
	const onChangeDiet = (value) => {
		setDietChecked(value);
	};

	const handleFilters = () => {
		setShowFilters((prevState) => !prevState);
	};

	const handleChange = (e) => {
		debouceRequest(e.target.value);
	};

	return (
		<div className="search_container">
			<div className="filters_container">
				<div onClick={handleFilters}>
					<Filter />
					<span>{t("filter.title")}</span>
					{totalFilter ? (
						<span className="total_filter">{totalFilter}</span>
					) : null}
				</div>
				<i className="icon" onClick={handleFilters}>
					<ArrowDown />
				</i>
				<div className={showFilters ? "filters" : "filters-hide"}>
					<h5 className="filters_title">Filtrer</h5>
					<div onClick={handleFilters} className="cross_icon">
						<Cross />
					</div>
					<div className="season_filters">
						<div className="tags_container">
							<h5>{t("season.tag.title")}</h5>
							<ul>
								{seasonTags.data.map((f) => {
									return (
										<li
											onClick={() => {
												setSeasonFilter(f.attributes.name);
												onChangeSeason(f.attributes.name);
											}}
											key={f.attributes.name}
										>
											<input
												type="checkbox"
												name="filters"
												onChange={() => {
													setSeasonFilter(f.attributes.name);
													onChangeSeason(f.attributes.name);
												}}
												checked={seasonChecked === f.attributes.name}
											/>
											<label>{f.attributes.name}</label>
										</li>
									);
								})}
							</ul>
						</div>
						<div className="tags_container">
							<h5>{t("diet.tag.title")}</h5>
							<ul>
								{dietTags.data.map((f) => {
									return (
										<li
											onClick={() => {
												setDietFilter((prev) => [...prev, f.attributes.name]);
												onChangeDiet(f.attributes.name);
											}}
											key={f.attributes.name}
										>
											<input
												type="checkbox"
												name="filters"
												checked={dietFilter?.includes(f.attributes.name)}
											/>
											<label>{f.attributes.name}</label>
										</li>
									);
								})}
							</ul>
						</div>
					</div>
					<div className="button_container">
						<span
							className="reset_button"
							onClick={() => {
								setSeasonFilter(undefined),
									setDietChecked(undefined),
									setSeasonChecked(undefined);
								setDietFilter(undefined);
								setShowFilters((prev) => !prev);
							}}
						>
							<RefreshArrow />
							{t("filter.button.reset")}
						</span>
						<span className="apply_button" onClick={handleFilters}>
							{t("filter.button.apply")}
						</span>
					</div>
				</div>
			</div>
			<div className="search_bar_container">
				<Search />
				<input
					placeholder={t("search.placeholder")}
					type="search"
					onChange={handleChange}
				></input>
			</div>
		</div>
	);
}
